// extracted by mini-css-extract-plugin
export default {"questionLabel":"styles_questionLabel__ZHWJL","questionDeleteButton":"styles_questionDeleteButton__iDHil"};